import type {
  PublicSignerProgressRequest,
  PublicSignerSessionResponse
} from '../publicSignerTypes';

import {
  buildPublicSignerFieldSnapshot,
  hasPublicSignerSignatureEntryValue
} from './buildFieldSnapshot';
import type { PublicSignerFieldDraftValues } from './types';

export function buildPublicSignerProgressRequest(
  session: PublicSignerSessionResponse,
  fieldDraftValues: PublicSignerFieldDraftValues,
  isDisclosureAccepted: boolean
): PublicSignerProgressRequest {
  const fields = buildPublicSignerFieldSnapshot(session, fieldDraftValues);

  return {
    ...(hasPublicSignerSignatureEntryValue(fields) && isDisclosureAccepted
      ? { disclosure_accepted: true }
      : {}),
    fields
  };
}
